import {useState} from 'react'
import {useCountDown} from 'ahooks'

import {isEmail, isPhoneNumber} from '#/lib/validator'
import server from '#/server'
import {type VerificationPurpose} from '#/server/rice'

/**
 * 发验证码 + 60 秒倒计时。
 *
 * 从 core 的两个接口(`/sms/send`、`/email/send`,用数字 codeType 区分用途)
 * 换成 rice 的 `/api/verification_codes`,用途是可读的字符串。
 *
 * rice 服务端**也有** 60 秒频率限制 —— core 那边没有任何限制,
 * 前端这个倒计时是唯一的防线,绕过它就能无限轰炸一个手机号。
 */
export default function useSMS() {
  const [targetDate, setTargetDate] = useState<number | undefined>()
  const [countdown, formattedRes] = useCountDown({targetDate})
  const [executing, setExecuting] = useState(false)

  return {
    ticking: executing || !!countdown,
    countdownText: countdown ? `${formattedRes.seconds}s` : '',
    send: async (receiver: string, purpose: VerificationPurpose) => {
      const isPhone = isPhoneNumber(receiver)
      if (!isPhone && !isEmail(receiver)) {
        throw new Error('手机号或邮箱不正确')
      }

      setExecuting(true)
      try {
        await server.rice.sendVerificationCode(
          isPhone
            ? {channel: 'sms', purpose, phone: receiver, phone_region: '86'}
            : {channel: 'email', purpose, email: receiver},
        )
        setTargetDate(Date.now() + 60 * 1000)
      } finally {
        setExecuting(false)
      }
    },
  }
}
